import { Observable } from 'rxjs';

import {
  FEAT_TITLE as PLAN_MANAGER_FEAT_TITLE,
  FeatureEnum as SearchPlanManagerItemEnum
} from '@app/plan-manager/plan-manager.model';

export enum SearchItemEnum {
  SUPPORT = 'SUPPORT',
  LIST_PLANS = 'LIST_PLANS',
  PROFILE = 'PROFILE',
  OPEN_INSURANCE = 'OPEN_INSURANCE',
  PRIVACY = 'PRIVACY'
}

type SearchItem = keyof typeof SearchItemEnum;
type SearchPlanManagerItem = keyof typeof SearchPlanManagerItemEnum;

export const SEARCH_ITEM_TITLE = {
  ...PLAN_MANAGER_FEAT_TITLE,
  SUPPORT: 'Fale conosco',
  LIST_PLANS: 'Acessar outro plano',
  PROFILE: 'Meus Dados',
  OPEN_INSURANCE: 'Open insurance',
  PRIVACY: 'Privacidade'
} satisfies Readonly<{
  [key in SearchItem | SearchPlanManagerItem]: string;
}>;

export const SEARCH_ITEM_ICON_URL = {
  SUPPORT: 'assets/svg/search/MENU.svg',
  LIST_PLANS: 'assets/svg/search/MENU.svg',
  PROFILE: 'assets/svg/search/PROFILE_MENU.svg',
  OPEN_INSURANCE: 'assets/svg/search/PROFILE_MENU.svg',
  PRIVACY: 'assets/svg/search/PROFILE_MENU.svg'
} satisfies Readonly<{
  [key in SearchItem]: string;
}>;

export interface ISearchItem {
  isPlanManagerItem: boolean;
  id: SearchItemEnum | SearchPlanManagerItemEnum;
  name: string;
  iconUrl: string;
  keywords: string[];
  isInSearchResultsList: boolean;
  isLoading: boolean;
  isEligible?: boolean;
  onSelection: () => void;
}

export type SearchEligibilityCheckingMethod = () => Observable<unknown>;
export type SearchSelectionMethod = () => Observable<void | unknown>;

type ISearchEligibilityCheckingMethods<T = SearchEligibilityCheckingMethod> = {
  isListPlansEligible: T;
};

type ISearchSelectionMethods<T = SearchSelectionMethod> = {
  onSupportSelection: T;
  onListPlansSelection: T;
  onProfileSelection: T;
  onOpenInsuranceSelection: T;
  onPrivacySelection: T;
};

export type ISearchMethods = ISearchEligibilityCheckingMethods &
  ISearchSelectionMethods;

export const SEARCH_ELIGIBILITY_CALLS = {
  LIST_PLANS: 'isListPlansEligible'
} satisfies Readonly<{
  [key in SearchItem]?: keyof ISearchEligibilityCheckingMethods;
}>;

export const SEARCH_SELECTION_CALLS = {
  SUPPORT: 'onSupportSelection',
  LIST_PLANS: 'onListPlansSelection',
  PROFILE: 'onProfileSelection',
  OPEN_INSURANCE: 'onOpenInsuranceSelection',
  PRIVACY: 'onPrivacySelection'
} satisfies Readonly<{
  [key in SearchItem]: keyof ISearchSelectionMethods;
}>;

const balanceKeywords = [
  'saldo previdência',
  'consultar saldo',
  'detalhamento'
];
export const searchItemKeywords = {
  NEW_CONTRIBUTION: ['mudar minha contribuição mensal', 'alterar mensalidade'],
  EXTRA_CONTRIBUTION: [
    'contribuição extra',
    'pagamento extra',
    'contribuir mais'
  ],
  DEPARTURE_DATE: [
    'mudar idade',
    'idade de saída',
    'alterar idade',
    'atrasar saída',
    'saída do plano',
    'aposentar'
  ],
  NEW_DIVERSIFICATION: [
    'diversificar',
    'alterar fundos',
    'investimentos',
    'mudar fundos'
  ],
  BOLETOS: ['boletos em aberto', 'pagamento boleto', 'segunda via'],
  WITHDRAW: ['resgatar saldo', 'resgatar previdência'],
  VERIFY_SURRENDER: ['status resgate'],
  CERTIFICATE: ['comprovante plano', 'comprovante'],
  DEFINE_INCOME: [
    'aposentadoria',
    'finalizar minha previdência',
    'receber aposentadoria'
  ],
  CHECKUP: ['saúde previdência', 'status do plano', 'minha previdência'],
  INCOME_TAX: ['imposto de renda', 'recibo de rendimentos'],
  BALANCE: balanceKeywords,
  MONTHLY_PROFITABILITY: balanceKeywords,
  SUPPORT: ['central de ajuda', 'central de atendimento', 'call center'],
  LIST_PLANS: ['outros planos', 'mudar de plano', 'alterar plano'],
  PROFILE: ['dados pessoais', 'endereço', 'email', 'alterar dados', 'senha'],
  OPEN_INSURANCE: ['enviar dados', 'mudar previdência', 'seguridade'],
  PRIVACY: ['lgpd', 'segurança', 'privacidade', 'dados pessoais', 'senha'],
  BENEFICIARIES: ['beneficiarios', 'beneficíarios', 'herdeiros'],
  DOCUMENTS: [
    'documentos',
    'arquivos',
    'comprovantes',
    'informe de rendimentos',
    'extrato regulamentar'
  ],
  JUNIOR_PLAN_HIRING: [],
  IOF_DECLARATION: [],
  BALANCE_RANGE_TAXATION: []
} satisfies Readonly<{
  [key in SearchItem | SearchPlanManagerItem]: string[];
}>;

export { SearchPlanManagerItemEnum };
